import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ILocation } from '@rbi-ctg/frontend';
import { MarkerTypes, useMap } from 'hooks/use-map';

interface IMapDeliveryAddress {
  coordinates?: ILocation;
  enableDeliveryGeolocation?: boolean;
}

const MapView = styled.div<{ $enableDeliveryGeolocation?: boolean }>`
  width: 100%;
  height: ${props => (props.$enableDeliveryGeolocation ? '10rem' : '35vh')};
  max-width: 100%;
  margin: 0 auto;
`;

export const MapFallbackInputWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-block-start: 1rem;
`;

export const MapDeliveryAddress = ({
  coordinates,
  enableDeliveryGeolocation,
}: IMapDeliveryAddress) => {
  const { map, createMarker } = useMap(
    coordinates
      ? {
          position: coordinates,
        }
      : undefined
  );

  useEffect(() => {
    const marker = createMarker({ type: MarkerTypes.User, location: coordinates });
    if (marker) {
      marker.active();
    }
  }, [coordinates, map, createMarker]);

  return (
    <MapFallbackInputWrapper>
      <MapView
        $enableDeliveryGeolocation={enableDeliveryGeolocation}
        data-testid="map-delivery-address"
      >
        {map}
      </MapView>
    </MapFallbackInputWrapper>
  );
};
